import { AnswerSource, QuestionAnswer } from "@/zapi-frontend/shared/const/validation-questions";

const answerStyles = {
  button: {
    user: {
      yes: "bg-innoveraGreen-500 text-white",
      no: "bg-innoveraRed-400 text-white",
      na: "bg-innoveraZinc-200 text-innoveraZinc-900",
      null: ""
    },
    ai: {
      yes: "bg-innoveraGreen-50 text-innoveraGreen-500",
      no: "bg-innoveraRed-50 text-innoveraRed-400",
      na: "bg-innoveraZinc-100 text-innoveraZinc-900",
      null: ""
    }
  },
  explanation: {
    user: {
      yes: "bg-innoveraGreen-50 text-innoveraGreen-700",
      no: "bg-innoveraRed-50 text-innoveraRed-400",
      na: "bg-innoveraZinc-100 text-innoveraZinc-900",
      null: ""
    },
    ai: {
      yes: "bg-innoveraGreen-50 text-innoveraGreen-700",
      no: "bg-innoveraRed-50 text-innoveraRed-400",
      na: "bg-innoveraZinc-100 text-innoveraZinc-900",
      null: ""
    }
  }
} as const;

export const getAnswerStyles = (
  type: "button" | "explanation",
  answer: QuestionAnswer,
  answerSource: AnswerSource,
  targetAnswer: QuestionAnswer
): string => {
  if (answer !== targetAnswer || !answerSource) return "";

  const key = answer || "null";
  return answerStyles[type][answerSource]?.[key as keyof (typeof answerStyles)[typeof type][typeof answerSource]] || "";
};

export const baseButtonClasses = "gap-1.5 px-4 transition-all duration-100 rounded-[6px]";
export const baseExplanationClasses = "p-3";
